// extracted by mini-css-extract-plugin
module.exports = {"container":"ShoppingCart_container__AdPWj"};